"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunk2VCHSK65_js = require('./chunk-2VCHSK65.js');
var chunkLXX3SSRV_js = require('./chunk-LXX3SSRV.js');
var reactNavigationMenu = require('@radix-ui/react-navigation-menu');
var t = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var t__default = /*#__PURE__*/_interopDefaultLegacy(t);

var a=t__default["default"](reactNavigationMenu.Trigger)`
  width: 100%;
  padding-left: var(--spacing-large);
  padding-right: var(--spacing-large);
  border: none;
  background-color: transparent;

  :hover,
  &.active {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    ${chunkLXX3SSRV_js.b}:first-child {
      color: var(--color-blurple-600);
    }
  }

  &.active {
    ${chunk2VCHSK65_js.d} {
      font-weight: var(--font-weight-bold);
    }
  }

  [data-state='open'] {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    ${chunkLXX3SSRV_js.b}:first-child {
      color: var(--color-blurple-600);
    }
  }
`;var c={Root:reactNavigationMenu.Root,List:reactNavigationMenu.List,Item:reactNavigationMenu.Item,Link:reactNavigationMenu.Link,Trigger:a,Content:reactNavigationMenu.Content};

exports.a = c;
